import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import translations from '../translations';

const LanguageContext = createContext();

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
];

const SUPPORTED_CODES = LANGUAGES.map(l => l.code);

function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || '';
  const prefix = browserLang.slice(0, 2).toLowerCase();
  return SUPPORTED_CODES.includes(prefix) ? prefix : 'en';
}

function getInitialLanguage() {
  const stored = localStorage.getItem('ascifiw3-lang');
  if (stored && SUPPORTED_CODES.includes(stored)) return stored;
  return detectBrowserLanguage();
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback((code) => {
    setLanguageState(code);
    localStorage.setItem('ascifiw3-lang', code);
  }, []);

  useEffect(() => {
    localStorage.setItem('ascifiw3-lang', language);
  }, [language]);

  const t = useCallback((path) => {
    const keys = path.split('.');
    let result = translations[language];
    for (const key of keys) {
      if (result && result[key] !== undefined) {
        result = result[key];
      } else {
        return path;
      }
    }
    return result;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
